import { useState } from 'react';

export default function GradeTooltip({ grade, children }) {
  const [show, setShow] = useState(false);
  return (
    <span className="relative inline-block" onMouseEnter={() => setShow(true)} onMouseLeave={() => setShow(false)}>
      {children}
      {show && (
        <div className="absolute z-50 bottom-full left-0 mb-2 w-[340px] bg-[#0F1629] border border-[#6366F1]/30 rounded-xl p-4 shadow-2xl" data-testid="grade-tooltip">
          <div className="text-[10px] font-bold text-[#F8FAFC] uppercase tracking-wider mb-2">
            {grade === 'AUDIT-GRADE' ? 'AUDIT-GRADE CRITERIA' : grade === 'OPERATIONS-GRADE' ? 'OPERATIONS-GRADE CRITERIA' : grade === 'UNAUDITED' ? 'UNAUDITED' : 'OBSERVATIONAL CRITERIA'}
          </div>
          {grade === 'AUDIT-GRADE' ? (
            <div className="space-y-1 text-[9px] font-mono text-[#94A3B8]">
              <div>◆ Immutable timestamp present and verified</div>
              <div>◆ Cryptographic signature valid</div>
              <div>◆ All required fields populated — no missing data</div>
              <div>◆ No unresolved integrity failures on this record</div>
              <div>◆ Reconstruction method is SDK Capture, Provider Log,</div>
              <div className="pl-3">or equivalent in-line capture</div>
              <div>◆ At least one independent corroborating source</div>
              <div className="mt-2 text-[#64748B]">Records that meet most but not all criteria receive Operations-Grade. Records with significant missing fields receive Observational.</div>
              <div className="mt-1 text-[#475569]">Proof grade is recalculated automatically when new corroboration is received or gaps are remediated.</div>
            </div>
          ) : grade === 'OPERATIONS-GRADE' ? (
            <div className="space-y-1 text-[9px] font-mono text-[#94A3B8]">
              <div>◆ Log-ingested or partially reconstructed</div>
              <div>◆ Most required fields present</div>
              <div>◆ Some fields reconstructed or inferred</div>
              <div>◆ Suitable for internal governance use</div>
              <div className="mt-2 text-[#64748B]">Upgrade to AUDIT-GRADE by connecting additional corroborating sources or completing missing fields.</div>
            </div>
          ) : grade === 'UNAUDITED' ? (
            <div className="space-y-1 text-[9px] font-mono text-[#94A3B8]">
              <div>○ No Classification Evidence Record exists</div>
              <div>○ No Control State captured</div>
              <div>○ Decisions not included in evidence packages</div>
              <div className="mt-2 text-[#64748B]">Start a Classification Review to create a governance proof chain for this system.</div>
            </div>
          ) : (
            <div className="space-y-1 text-[9px] font-mono text-[#94A3B8]">
              <div>◆ Partial capture, required fields missing</div>
              <div>◆ Explicitly labeled for gap identification</div>
              <div>◆ Not suitable for audit submission</div>
            </div>
          )}
        </div>
      )}
    </span>
  );
}
